const swymCustomFunctions = {
    'fetchLists': async function(swat){
        return new Promise(async (resolve, reject) => {
            swat.fetchLists({
            callbackFn: lists => resolve(lists),
            errorFn: err => reject(err)
            });
        });
    },
    'fetchListProductsDetails': async function (swat, lid){
        return new Promise(async (resolve, reject) => {
            swat.fetchListCtx(
              { lid: lid },
              listContents => resolve(listContents),
              error => reject(error)
            );
        });
    },
    'createList': async function (swat, listTitle){
        // Fallback to default if title is undefined or empty
        const title = listTitle || window.defaultListTitle || "Your Pantry Picks";
        console.log('creating list:', title);
        let listConfig = { "lname": title };
        return new Promise(async (resolve, reject) => {
            swat.createList(listConfig,
                list => resolve(list),
                error => reject(error)
            )
        })
    },
    'renameList': function(swat, lid, listTitle) {
        const listUpdateConfig = {
            "lname": listTitle,
            "lid": lid
        }
        return new Promise(async (resolve, reject) => {
            swat.updateList(listUpdateConfig,
                list => resolve(list),
                error => reject(error)
            );
        })
    },
    'deleteLists': async function (swat, lists) {
        try {
            await Promise.all(lists.map(list =>
                new Promise((resolve, reject) => {
                    swat.deleteList(
                        list.lid,
                        obj => resolve(obj),
                        error => reject(error)
                    );
                })
            ));
            return 'All lists deleted successfully';
        } catch (error) {
            console.error('Error encountered while deleting the list', error);
            throw error;
        }
    },
    'addProductsToList': async function (swat, products, lid){
        // Add many products to a list in batches of 10 (API limitation)
        // API reference: https://developers.getswym.com/docs/add-many-products-to-a-list
        if (!products || products.length === 0) {
            return [];
        }
        
        const BATCH_SIZE = 10;
        const batches = [];
        
        // Split products into batches of 10
        for (let i = 0; i < products.length; i += BATCH_SIZE) {
            batches.push(products.slice(i, i + BATCH_SIZE));
        }
        
        // Process batches sequentially to avoid overwhelming the API
        const results = [];
        for (const batch of batches) {
            try {
                const result = await new Promise((resolve, reject) => {
                    swat.addProductsToList(
                        lid,
                        batch,
                        result => resolve(result),
                        error => reject(error)
                    );
                });
                results.push(result);
            } catch (error) {
                console.error('Error adding batch of products to list:', error);
                throw error;
            }
        }
        
        return results.flat();
    },
    'updateHeaderCounter': function (){
        const productsCount = window.listProductsCount;
        var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter");
        if (counter_elem) {
            for (var i = 0; i < counter_elem.length; i++) {
                counter_elem[i].style.display = 'flex';
                const hasProductsInWishlist = productsCount > 0;
                counter_elem[i].classList.toggle('show-badge', hasProductsInWishlist);
                counter_elem[i].innerHTML = productsCount;
            }
        }
    },
    'getListsProducts': async function (swat, lists) {
        return Object.values(
            (
              await Promise.all(
                lists.map(async (list) =>
                  swymCustomFunctions.fetchListProductsDetails(swat, list.lid)
                )
              )
            )
            .flat()
            .reduce((acc, { epi, empi, du }) => {
                acc[epi] = { epi, empi, du };
                return acc;
            }, {})
        );
    },
    'getAllProductsWithChannel': async function (swat, lists) {
        // Get all products from all lists with their channel information
        const allProducts = [];
        for (const list of lists) {
            const products = await swymCustomFunctions.fetchListProductsDetails(swat, list.lid);
            products.forEach(product => {
                allProducts.push({
                    ...product,
                    originalLid: list.lid,
                    originalLname: list.lname
                });
            });
        }
        return allProducts;
    },
    'removeProductFromList': async function (swat, lid, product) {
        return new Promise(async (resolve, reject) => {
            swat.deleteFromList(
                lid,
                product,
                result => resolve(result),
                error => reject(error)
            );
        });
    },
    'removeProductsFromListBatch': async function (swat, lid, products) {
        // Remove many products from a list in batches of 10 (API limitation)
        // API reference: https://developers.getswym.com/docs/remove-many-products-from-a-list
        if (!products || products.length === 0) {
            return [];
        }
        
        const BATCH_SIZE = 10;
        const batches = [];
        
        // Split products into batches of 10
        for (let i = 0; i < products.length; i += BATCH_SIZE) {
            batches.push(products.slice(i, i + BATCH_SIZE));
        }
        
        // Process batches sequentially to avoid overwhelming the API
        const results = [];
        for (const batch of batches) {
            try {
                const result = await new Promise((resolve, reject) => {
                    swat.removeProductsFromList(
                        lid,
                        batch,
                        result => resolve(result),
                        error => reject(error)
                    );
                });
                results.push(result);
            } catch (error) {
                console.error('Error removing batch of products from list:', error);
                throw error;
            }
        }
        
        return results.flat();
    },
    'init': async function(swat) {
        try {
            // Validate required global variables
            if (!window.defaultListTitle) {
                console.error('Swym default list title not configured. Please set window.defaultListTitle');
                return;
            }

            // Track if any modifications were made
            let modificationsMade = false;

            // 1. Fetch the lists
            let lists = await swymCustomFunctions.fetchLists(swat);
            const listCount = lists.length;

            // 2. Check the number of lists present
            if (listCount === 0) {
                // If 0 lists, create only default list (no POS list needed)
                console.log('No lists found. Creating default list.');
                await swymCustomFunctions.createList(swat, window.defaultListTitle);
                modificationsMade = true;
                lists = await swymCustomFunctions.fetchLists(swat);
            } else {
                // Simplified logic: Only one default list needed, merge all products into it
                
                let defaultList = null;
                const allProductsToMerge = []; // Collect all products from all lists
                
                // Find existing default list
                defaultList = lists.find(list => 
                    list && list.lname && list.lname.toLowerCase() === window.defaultListTitle.toLowerCase()
                );
                
                // If default list doesn't exist, use first list or create new one
                if (!defaultList) {
                    if (lists[0] && lists[0].lid) {
                        defaultList = lists[0];
                        await swymCustomFunctions.renameList(swat, defaultList.lid, window.defaultListTitle);
                        modificationsMade = true;
                    } else {
                        defaultList = await swymCustomFunctions.createList(swat, window.defaultListTitle);
                        modificationsMade = true;
                    }
                }
                
                // Refresh lists after potential renaming
                lists = await swymCustomFunctions.fetchLists(swat);
                if (defaultList && defaultList.lid) {
                    defaultList = lists.find(list => list && list.lid === defaultList.lid);
                }
                
                // Validate default list exists
                if (!defaultList) {
                    console.error('Failed to find or create default list');
                    return;
                }
                
                // Collect all products from all lists (simple merge with basic attributes only)
                for (const list of lists) {
                    // Skip the default list - we'll get its products separately to avoid duplicates
                    if (list.lid === defaultList.lid) {
                        continue;
                    }
                    
                    const products = await swymCustomFunctions.fetchListProductsDetails(swat, list.lid) || [];
                    products.forEach(product => {
                        // Validate product has required properties
                        if (!product || !product.epi || !product.empi || !product.du) {
                            console.warn('Skipping product with missing required properties:', product);
                            return;
                        }
                        
                        // Simple product payload with only basic attributes
                        allProductsToMerge.push({
                            product: {
                                epi: product.epi,
                                empi: product.empi,
                                du: product.du
                            },
                            sourceLid: list.lid
                        });
                    });
                }
                
                // Get current products in default list to avoid duplicates
                const currentDefaultProducts = await swymCustomFunctions.fetchListProductsDetails(swat, defaultList.lid) || [];
                const defaultEpiSet = new Set(currentDefaultProducts.filter(p => p && p.epi).map(p => p.epi));
                
                // Filter out duplicates and prepare products to add
                const productsToAdd = allProductsToMerge
                    .filter(item => !defaultEpiSet.has(item.product.epi))
                    .map(item => item.product);
                
                // Add all products to default list
                if (productsToAdd.length > 0) {
                    await swymCustomFunctions.addProductsToList(swat, productsToAdd, defaultList.lid);
                    modificationsMade = true;
                }
                
                // Group products by source list for removal
                const productsBySource = {};
                allProductsToMerge.forEach(item => {
                    if (!productsBySource[item.sourceLid]) {
                        productsBySource[item.sourceLid] = [];
                    }
                    productsBySource[item.sourceLid].push({ 
                        epi: item.product.epi, 
                        empi: item.product.empi, 
                        du: item.product.du 
                    });
                });
                
                // Remove all products from source lists (they've been merged into default)
                for (const [sourceLid, products] of Object.entries(productsBySource)) {
                    if (sourceLid !== defaultList.lid && products.length > 0) {
                        await swymCustomFunctions.removeProductsFromListBatch(swat, sourceLid, products);
                        modificationsMade = true;
                    }
                }
                
                // Delete all other lists (only keep default list)
                const listsToDelete = lists.filter(list => 
                    list && list.lid && list.lid !== defaultList.lid
                );
                
                if (listsToDelete.length > 0) {
                    await swymCustomFunctions.deleteLists(swat, listsToDelete);
                    modificationsMade = true;
                }
                
                lists = await swymCustomFunctions.fetchLists(swat);
            }

            // Final fetch to get updated lists
            lists = await swymCustomFunctions.fetchLists(swat);
            const finalDefaultList = lists.find(list => 
                list && list.lname && list.lname.toLowerCase() === window.defaultListTitle.toLowerCase()
            );

            // Set global variables
            if (finalDefaultList && finalDefaultList.lid) {
                window.defaultListId = finalDefaultList.lid;
                window.currentActiveListId = finalDefaultList.lid;
            }

            console.log('Swym list initialization - SUCCESS', {
                defaultListId: window.defaultListId,
                modificationsMade: modificationsMade
            });
          
            document.dispatchEvent(new CustomEvent('swym:default-list-executed'));

            // Reload page if any modifications were made to show updated UI
            if (modificationsMade && window.location.pathname == '/pages/swym-wishlist') {
                console.log('Modifications were made. Reloading page to show updated lists.');
                window.location.reload();
                return;
            }

            swat.ui.open = function(){
                location.href = `${Shopify.routes.root}pages/swym-wishlist`;
            }
            document.querySelectorAll('.swym-header-container').forEach(element => 
                element.style.visibility = 'visible'
            );
        } catch (error) {
            console.error('Error occurred during initialization:', error);
            // Fallback: try to create default list
            try {
                await swymCustomFunctions.createList(swat, window.defaultListTitle);
                // Reload page after fallback list creation
                console.log('Fallback list creation succeeded. Reloading page.');
                window.location.reload();
            } catch (fallbackError) {
                console.error('Fallback list creation also failed:', fallbackError);
            }
        }
    }
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCustomFunctions.init);